import swiperWidget from './swiperWidget'; // SLIDESHOW IMPORTED

export default function () {
  const widgetName = 'videoWidget';
  const widgetOpts = videoWidgetOpts;

  $(`#${widgetName}`).append('<iframe></iframe>');
  $(`#${widgetName}`).wrap('<div id="videoSection"></div>');

  $(`#${widgetName}`).videoWidget({

    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , maxVideos: 1
    , autoPlayVideo: true
    , loopVideo: true
    , trackingGA: {
      present: false,
      event: 'event',
      gaObj: {
        eventCategory: 'Videos',
        eventAction: '',
        eventLabel: '',
        loopVideo: true
      }
    }
    , videoWidgetLoaded: function (data) { 
      if (data.Slides.length < 1) { // CONDITION TO COUNT VIDEO SLIDES
        $('#videoSection').remove(); // IF VIDEO IS NOT UPDATED WILL REMOVE VIDEOWIDGET AND RENDER SLIDESHOW
        swiperWidget();
      }
    }
  });
};
